<template>
  <div class="wrapper courses-filters-wrapper">
    <div class="normal-container special-container">
      <FilterItem :filter-list="filtersData.slice(0, 4)" @changeFilter="handleChangeFilter" @changeColor="hadndleChangeColor" />
    </div>
    <!-- <div class="expanse-container" :style="{'height': expanseHeight}">
      <div ref="expanseContainer" class="normal-container">
        <FilterItem :filter-list="filtersData.slice(4)" @changeFilter="handleChangeFilter" @changeColor="hadndleChangeColor" />
      </div>
    </div> -->
    <transition name="filter-fade">
      <div v-if="isExpanse" class="normal-container">
        <FilterItem :filter-list="filtersData.slice(4)" @changeFilter="handleChangeFilter" @changeColor="hadndleChangeColor" />
      </div>
    </transition>
    <div class="expanse-bottom">
      <div class="bottom-result">
        {{ $t('featureComponents.CoursesFilters.resultsNum', { total }) }}
      </div>
      <div v-if="filtersData.length > 4" class="bottom-more" @click="handleExpanse">
        <div class="iconfont icon-double-arrow-top" :class="{'icon-reverse': !isExpanse}" />
        <span class="expanse-text">{{ isExpanse ? langContext.retract : langContext.more }}</span>
      </div>
      <div class="expanse-btn" @click="handleResetDebounce">
        <div class="iconfont icon-reset" />
        <span>
          {{ langContext.reset }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from './mixin'
import { debounce } from 'common/utils';
import FilterItem from './FilterItem/web';

export default {
  components: {
    FilterItem,
  },
  mixins: [mixin],
  data() {
    return {
      langContext: this.$t('featureComponents.CoursesFilters'),
      expanseHeight: 0, // 展开筛选项的高度
      isExpanse: false, // 是否展开所有筛选项
      urlSpecialParams: [], // 其它的url参数
      filtersData: [],
    }
  },
  methods: {
    // 初始化筛选项的数据
    init() {
      this.getFilterData()
    },
    handleChangeFilter(data) {
      this.Sensors.track('filter_course_web', {
        filter_type: data.filterType,
        filter_name: data.item.name,
      })
      const parentIdx = this.getParentIndex(data.filterType)
      this.changeFilterDebounce(data.item, data.index, parentIdx)
    },
    hadndleChangeColor(data) {
      const parentIdx = this.getParentIndex(data.filterType)
      this.changeRateColor(data.item, data.index, parentIdx, data.isHover)
    },
    // 改变筛选项 防抖
    changeFilterDebounce: debounce(function (item, index, parentIdx) {
      this.changeFilter(item, index, parentIdx)
    }, 200),
    // 改变单个筛选项
    changeFilter(curItem, curIdx, parentIdx) {
      // 点击 all && all未被选中
      if (curIdx === 0 && !curItem.selected) {
        this.filtersData[parentIdx].dataList.forEach((item, index) => {
          this.filtersData[parentIdx].dataList[index].selected = false
          if (this.filtersData[parentIdx].filterType === 'difficulty') this.changeRateColor(item, index, parentIdx)
        })
        this.filtersData[parentIdx].dataList[0].selected = true
      } else { // 非 all && 可选择
        this.filtersData[parentIdx].dataList[curIdx].selected = !curItem.selected
        this.filtersData[parentIdx].dataList[0].selected = this.getFilterState(parentIdx)
        if (this.filtersData[parentIdx].filterType === 'difficulty') this.changeRateColor(curItem, curIdx, parentIdx)
      }
      this.updateHistoryParams()
      this.sendChangeFilter()
    },
    // 获取当前筛选项状态
    getFilterState(index) {
      return this.filtersData[index].dataList.slice(1).every((item) => !item.selected)
    },
    // 展示所有筛选项
    handleExpanse() {
      // this.expanseHeight = this.isExpanse ? 0 : `${this.$refs.expanseContainer.offsetHeight}px`
      this.isExpanse = !this.isExpanse
      this.handleMoreTrack(this.isExpanse)
    },
    // 重置筛选项 防抖
    handleResetDebounce: debounce(function () {
      this.handleAllReset()
    }, 200),
  },
}
</script>

<style lang="scss" scoped>
.filter-fade-enter-active {
  transition: opacity 0.6s;
}

.filter-fade-enter {
  opacity: 0;
}

.courses-filters-wrapper {
  background: #fff;
  border-radius: 16px;
  margin-bottom: 40px;
  padding-top: 40px;
}

.normal-container {
  padding: 0 40px;
}

.special-container {
  /deep/.filter-split:first-child {
    display: none;
  }
}

.expanse-container {
  height: 0;
  overflow: hidden;
  transition: height 0.4s;
}

.expanse-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 78px;
  margin-top: 9px;
  padding: 0 40px;
  position: relative;
  border-top: 1px solid #f2f2f2;
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
  text-align: center;

  .bottom-result {
    color: rgba(0, 0, 0, 0.6);
  }

  .bottom-more {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: rgba(0, 0, 0, 0.6);
    cursor: pointer;

    .icon-double-arrow-top {
      padding-top: 1px;
      font-size: 12px;
      transform: scale(0.7);
    }

    .icon-reverse {
      transform: rotate(180deg) scale(0.7);
    }

    .expanse-text {
      margin-left: 6px;
    }
  }

  .expanse-btn {
    display: flex;
    padding: 7px 16px;
    color: var(--txt-color-link);
    cursor: pointer;
    border-radius: 14px;
    border: 1px solid var(--txt-color-link);

    .icon-reset {
      font-size: 12px;
      margin-right: 4px;
      padding-top: 1px;
    }

    &:hover {
      color: #fff;
      background: var(--txt-color-link);
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
  }
}
</style>
